module.exports = __webpack_public_path__ + "img/htkj_03.ca72779e.jpg";